import React, { useRef, useState } from 'react';
import { DropDown, Label, Button, List, ListItem } from './styles';
import ArrowDown from '../../../assets/icons/DropArrowdown';
import { useOutsideDrop } from '../../../hooks/useOutsideDrop';

import { handleValidation } from '../../../pages/FlowPane/utils';
import { useDispatch, useSelector } from 'react-redux';
import SaveNewVersion from '../../../pages/FlowPane/Modals/NewVersion';
import Save from '../../../pages/FlowPane/Modals/Save';
import RenameVersion from '../../../pages/FlowPane/Modals/RenameVersion';
import DeleteVersion from '../../../pages/FlowPane/Modals/DeleteVersion';
import { handleSetDefault } from '../../../state/flows/actions';
import { toastAlert } from '../../../components/Toastify/index';

const SaveButton = ({ elements, title, state, loadflow }) => {
  const user = useSelector((state) => state.auth.user);

  const [drop, setDrop] = useState(false);
  const wrapperRef = useRef(null);
  const clearDropdown = () => setDrop(false);

  const flow = useSelector((state) => state.flows.pane.flow);

  useOutsideDrop(wrapperRef, clearDropdown);

  //Modals
  const [showSave, setShowSave] = useState(false);
  const [showNewVersion, setShowNewVersion] = useState(false);
  const [showRename, setShowRename] = useState(false);
  const [showDelete, setShowDelete] = useState(false);



  const current = flow.current;
  const main = flow.main;

  const disableNewDefaultOptions = state === 'edition' &&
    main.default ?
    (main.default !== current._id)
    : main._id !== current._id




  const dispatch = useDispatch();

  //Validation
  const handleSave = (showModal) => {
    setDrop(false);
    handleValidation(elements, showModal);
  };

  const handleOpen = (showModal) => {
    setDrop(false);
    showModal(true);
  };

  const handleNewDefault = () => {
    dispatch(
      handleSetDefault({
        flowId: flow.main._id,
        versionId: flow.main._id !== flow.current._id ? flow.current._id : null,
      })
    )
      .then(() => {

        toastAlert({
          msg: `Fluxo  '${flow.current.title}' definida como PADRÃO.`,
        });
      })
      .catch((err) => {
        toastAlert({
          msg: `ERRO ao definir o fluxo'${flow.current.title}' como PADRÃO: ${err}`,
          isError: true,
        });
      });
    setDrop(false);
  };

  return (
    <>
      <DropDown drop={drop} ref={wrapperRef}>
        <Label onClick={() => handleSave(setShowSave)} drop={drop}>
          <p>{'SALVAR'}</p>
        </Label>
        <Button drop={drop} onClick={() => setDrop((prev) => !prev)}>
          <ArrowDown />
        </Button>
        <List drop={drop}>
          <ListItem onClick={() => handleSave(setShowSave)}>
            {'Salvar'}
          </ListItem>
          <ListItem
            disabled={state === 'creation'}
            onClick={() =>
              state !== 'creation' ? handleSave(setShowNewVersion) : undefined
            }
          >
            Salvar como nova versão
          </ListItem>
          <ListItem
            disabled={!disableNewDefaultOptions}
            onClick={disableNewDefaultOptions ? handleNewDefault : undefined}
          >
            Definir como modelo padrão
          </ListItem>
          <ListItem
            onMouseOver={(e) =>
              state === 'edition' && (e.target.style.color = 'red')
            }
            onMouseLeave={(e) =>
              state === 'edition' && (e.target.style.color = '#fff')
            }
            disabled={state === 'creation'}
            onClick={() =>
              state !== 'creation'
                ? handleOpen(setShowDelete, 'delete')
                : undefined
            }
          >
            {'Excluir modelo'}
          </ListItem>
        </List>
      </DropDown>

      <Save
        main={flow.main}
        current={flow.current}
        title={title}
        elements={elements}
        selector="#root"
        className="nodrag"
        isOpen={showSave}
        state={state}
        onClose={() => setShowSave(false)}
      />

      <SaveNewVersion
        main={flow.main}
        current={flow.current}
        state={state}
        loadflow={loadflow}
        title={title}
        elements={elements}
        user={user}
        isOpen={showNewVersion}
        onClose={() => setShowNewVersion(false)}
      />
      <RenameVersion
        main={flow.main}
        current={flow.current}
        title={title}
        state={state}
        elements={elements}
        user={user}
        isOpen={showRename}
        onClose={() => setShowRename(false)}
      />

      <DeleteVersion
        main={flow.main}
        current={flow.current}
        loadflow={loadflow}
        title={title}
        state={state}
        isOpen={showDelete}
        onClose={() => setShowDelete(false)}
      />
    </>
  );
};

export default SaveButton;
